import {
  ProductState,
  ProductStateStatus,
} from '@/shared/api/protocol-ts/api/billing_new/dto_product_new_pb';

export const isCoinSpendableSubscription = (product: ProductState): boolean => {
  const now = new Date();
  const start = product.Start?.toDate();
  const end = product.End?.toDate();

  return (
    product.Model?.Kind.case === 'Subscription' &&
    product.Status === ProductStateStatus.ProductStateStatusActive &&
    product.Paid &&
    !product.Deleted?.IsDeleted &&
    start !== undefined &&
    start <= now &&
    end !== undefined &&
    end > now
  );
};
